import { useEffect } from 'react';

/**
 * Hook for handling closing when clicking outside of an element
 * @param {React.node} el
 * @param {boolean} initialState
 */
// Hook
export function useOnClickOutsideSingle(dropdownRef, handler) {
    useEffect(
        () => {
            const listener = (event) => {
                const classList = [...event.target.classList.values()] || [];

                // this block of code may be deprecated
                let isSwalPopup = false;
                classList.forEach((classItem) => {
                    if (typeof classItem === 'string') {
                        if (classItem.toLowerCase().includes('swal2')) isSwalPopup = true;
                    }
                });

                // Do nothing if clicking - ref's element, descendent elements or portal elements (content rendered at bottom of DOM)
                if (
                    !dropdownRef.current ||
                    dropdownRef.current.contains(event.target) ||
                    isSwalPopup ||
                    event.target.closest('[role="portal"]') ||
                    event.target.closest('[role="alertdialog"]')
                ) {
                    return;
                }
                handler(event);
            };
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);
            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        },
        // Add ref and handler to effect dependencies
        // It's worth noting that because passed in handler is a new ...
        // ... function on every render that will cause this effect ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... passing it into this hook.
        [dropdownRef, handler]
    );
}
